import ContentVideo from './ContentVideo'

export default ContentVideo
